import React from 'react';

import {observer} from 'mobx-react';
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import {Text} from "../../../../../../../core/components/misc/text/text";
import styles from "./../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";

export class GameCenterHeaderModuleDetailsStatusGameTopScoreProps extends GameCenterHeaderModuleProps {}

export const GameCenterHeaderModuleDetailsStatusGameTopScore = observer(({controller}: GameCenterHeaderModuleDetailsStatusGameTopScoreProps) => {
  const {state} = controller;
  const {animation, isLive, topScoreText} = state;

  const shouldRenderTopScore: Boolean = !animation && !isLive && topScoreText;

  const topScoreTextProps = {
    text: topScoreText,
    className: classNames(styles.game_top_scores),
  };

  return shouldRenderTopScore ? <Text {...topScoreTextProps}/> : null
});
